import { colors } from "../../../../data/colors";
import { salesCodes } from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";

export const updatePersonDocData = async ({
  t,
  sltMode,
  data,
  docValues,
  writeDataParams,
  ifCommissionPaid,
  updateDocTable,
  usersList,
  updatePrices,
  updateActiveDoc,
  setDocValues,
  setMsg2,
  setModalData2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  let type = docValues.type;
  let tempDocValues = docValues;
  tempDocValues.updated = true;
  const prevPriceRate = tempDocValues.person?.TARCLI;
  tempDocValues.data[`${sltMode.target}${type}`] = writeDataParams({
    type,
    key: sltMode.target,
    value: data[`COD${sltMode.goMenu}`],
    field: "data",
    name: data[`NOM${sltMode.goMenu}`],
  });
  if (sltMode.target === "RES") {
    tempDocValues.data[`NRS${type}`] = writeDataParams({
      type,
      key: "NRS",
      value: data[`NOM${sltMode.goMenu}`],
      field: "data",
      name: "",
    });
  } else {
    tempDocValues.person = data;
    ["NOM", "DOM", "TEL", "CEL", "EMA"].forEach((e) => {
      tempDocValues.data[`${e}${type}`] = writeDataParams({
        type,
        key: e,
        value:
          e === "EMA"
            ? data[`${e}1${sltMode.goMenu}`]
            : e === "DOM"
              ? data[`${e}${sltMode.goMenu}`].length > 0
                ? data[`${e}${sltMode.goMenu}`][0].DOMDIR
                : ""
              : data[`${e}${sltMode.goMenu}`],
        field: "data",
        name: "",
      });
    });
    if (
      salesCodes.includes(type) &&
      data.AGECLI !== "" &&
      !ifCommissionPaid()
    ) {
      tempDocValues = updateDocTable(
        { CODUSU: data.AGECLI, ...usersList[data.AGECLI] },
        {
          codeKey: 0,
          field: "staff",
          returnData: true,
        },
        tempDocValues,
      );
    }
    if (type === "SEV") {
      try {
        const initIssues = await sendData({
          endPoint: "getInitIssues",
          payload: { code: data.CODCLI },
          logoutAction,
        });

        initIssues.issues.forEach((e: stdObject) => {
          const issueIndex = tempDocValues.issues.findIndex(
            (v: stdObject) => v.NUMSDD === e.CODSD1,
          );
          if (issueIndex > -1) {
            tempDocValues.issues[issueIndex][e.FIESD1] = e.TXTSD1;
          }
        });
      } catch (error) {
        console.log("getInitIssues error: ", error);
      }
    }
  }
  if (
    sltMode.target === "CLI" &&
    salesCodes.includes(tempDocValues.type) &&
    typeof prevPriceRate === "number" &&
    prevPriceRate !== data.TARCLI
  ) {
    setMsg2("custom2");
    setModalData2({
      title: tempDocValues.person.NOMCLI,
      label: capitalizeFirstLetter(
        t("p.wantToUpdatePrice", {
          thisCustomer: t("p.thisCustomer").toLowerCase(),
        }),
      ),
      buttons: [
        {
          label: t("p.update"),
          onClick: () => updatePrices(tempDocValues),
          color: colors.green,
        },
        {
          label: t("p.cancel"),
          onClick: () => {
            updateActiveDoc(tempDocValues);
            setDocValues({ ...tempDocValues });
            closeMsg(2);
          },
          color: colors.darkGrey,
        },
      ],
    });
  } else {
    updateActiveDoc(tempDocValues);
    setDocValues({ ...tempDocValues });
  }
};
